import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";
import {
  FaChevronDown,
  FaCloudDownloadAlt,
  FaFileInvoice,
  FaTicketAlt,
  FaClock,
  FaUsers,
  FaChevronUp,
  FaClipboard,
} from "react-icons/fa";
import { KYDAdminEvent, KYDEventReports } from "@common/interfaces/KYDEvent";

interface DownloadReportsDropdownProps {
  reports?: KYDEventReports;
}

interface ReportOption {
  key: keyof KYDEventReports;
  title: string;
  icon: any;
  description?: string;
}

const reportOptions: ReportOption[] = [
  {
    key: "settlement-pdf",
    title: "Settlement Report",
    icon: FaFileInvoice,
    description: "All sales data (PDF)",
  },
  {
    key: "tickets",
    title: "Ticket Holders Report",
    icon: FaTicketAlt,
    description: "List of all ticket holders (CSV)",
  },
  {
    key: "waitlist",
    title: "Waitlist Report",
    icon: FaClock,
    description: "Users on the event waitlist (CSV)",
  },
  {
    key: "sales-pdf",
    title: "Sales Report",
    icon: FaUsers,
    description:
      "Sales data without refunds, chargebacks, or waitlist activity (PDF)",
  },
  {
    key: "guestlist",
    title: "Guestlist Attendees Report",
    icon: FaClipboard,
    description: "List of all attendees on the guestlist (CSV)",
  },
];

const DownloadReportsDropdown = ({ reports }: DownloadReportsDropdownProps) => {
  const availableReports = reportOptions.filter(
    (option) => reports?.[option.key]?.url
  );

  const handleDownload = (url: string) => {
    window.open(url, "_blank");
  };

  if (availableReports.length === 0) {
    return (
      <Button
        isDisabled={true}
        variant="outline"
        leftIcon={<FaCloudDownloadAlt />}
      >
        No reports available
      </Button>
    );
  }

  return (
    <Menu>
      {({ isOpen }) => (
        <>
          <MenuButton
            as={Button}
            rightIcon={isOpen ? <FaChevronUp /> : <FaChevronDown />}
            leftIcon={<FaCloudDownloadAlt />}
            variant="outline"
            w={"280px"}
          >
            Download Reports
          </MenuButton>
          <MenuList>
            {availableReports.map((report) => (
              <MenuItem
                key={report.key}
                onClick={() => handleDownload(reports[report.key].url)}
                icon={<Icon as={report.icon} />}
              >
                <VStack align="flex-start" spacing={0} w={["full", "300px"]}>
                  <Text fontWeight="medium">{report.title}</Text>
                  <Text fontSize="xs" color="gray.600">
                    {report.description}
                  </Text>
                </VStack>
              </MenuItem>
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default DownloadReportsDropdown;
